import script from "./VContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./VContent.vue?vue&type=script&lang=ts&setup=true"

import "./VContent.vue?vue&type=style&index=0&id=15e7a928&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e7a928"]])

export default __exports__